export default async (context, payload) => {
    const endpoint = `${payload.oneLni.environment.current.apiLocation2}/warehouse-retaliation`;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;
    const moduleId = context.getters.moduleId;
    try {
        const response = await fetch(endpoint, {
            mode: 'cors',
        });
        const results = await response.json();
        if (results?.error?.length) {
            let message = results.error.join('; ');
            throw new Error(message);
        }
        context.commit('appState/SET_VALUE', {
            key: 'data',
            value: results,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'hasError',
            value: false,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'isInitialized',
            value: true,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'isLoading',
            value: false,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'load',
            value: false,
        }, {
            root: true,
        });
        return 'success';
    } catch (err) {
        if (moduleId) {
            setAttribute(
                context,
                `${moduleId}_post-submission-errors`,
                'items',
                {
                    level: 'Error',
                    message: 'Error collecting information.',
                },
            );
        }
        context.commit('appState/SET_VALUE', {
            key: 'isLoading',
            value: false,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'hasError',
            value: true,
        }, {
            root: true,
        });
        context.commit('appState/SET_VALUE', {
            key: 'load',
            value: false,
        }, {
            root: true,
        });
        return err;
    }
};